import React from "react";
import Select from "react-select";
import { Button } from "aible";

import BlueprintItem from "containers/View/Item/BlueprintItem";
import DatasetItem from "containers/View/Item/DatasetItem";
import RunItem from "containers/View/Item/RunItem";
import CurrentState from "containers/CurrentState/CurrentState";
import DeploymentItem from "containers/View/Item/DeploymentItem";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Setup from "components/Group/Setup";

import RelatedSuccess from "containers/CreateWizard/Success/RelatedSuccess";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

export default class Group extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showItem: undefined,
      detailSelected: false
    };
  }

  renderSetup(setup, hasHighlight) {
    const { group } = this.props;

    return (
      <Setup setup={setup} blueprint={group && group.blueprint ? group.blueprint : {}} hasHighlight={hasHighlight} />
    );
  }

  renderFields(title, fields, color) {
    return (
      <div className={title === "Blueprint Fields" ? styles.bpField : ""}>
        <div className={styles.tileHeaderTable} style={{ backgroundColor: color }}>
          {title}
        </div>
        {Object.keys(fields).length === 0 ? (
          <div className={styles.noDataInfoBox}>
            <div className={styles.noFieldsFound}>{"No Fields Found"}</div>
          </div>
        ) : (
          <div className={styles.infoBox}>
            {Object.keys(fields).map((f, i) => (
              <div className={styles.detailsFlex + " " + styles.inputField} title={fields[f].label} key={i}>
                <div>{fields[f].label}</div>
                <div className={styles.datasetType}>{"(" + fields[f].type + ")"}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderAutoCorrections(corrections) {
    return (
      <div>
        <div className={styles.tileHeaderTable}>{"Auto Corrections"}</div>
        <div className={styles.autoCorrection + " " + styles.infoBox}>
          {corrections.length === 0 ? (
            <div style={{ textAlign: "center" }}>No Corrections Made</div>
          ) : (
            corrections.map((f, i) => (
              <div className={styles.detailsFlex} title={f.message} key={i}>
                <div>{f.message}</div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }

  renderDatasetDetail() {
    const { group } = this.props;

    const dataset = group.dataset;
    const blueprintFields = group.blueprint ? group.blueprint.wizard.dataset.fields : [];

    if (dataset === undefined) {
      return <div />;
    }

    const includedFields = Object.keys(dataset.fields)
      .filter((f) => blueprintFields[f] !== undefined)
      .map((f) => dataset.fields[f]);

    const extraFields = Object.keys(dataset.fields)
      .filter((f) => blueprintFields[f] === undefined)
      .map((f) => dataset.fields[f]);

    const missedFields = Object.keys(blueprintFields)
      .filter((f) => dataset.fields[f] === undefined)
      .map((f) => blueprintFields[f]);

    const warnings = dataset.warnings;

    return (
      <div className={styles.detailContainer}>
        <div className={styles.detailsFlex}>
          <div className={styles.leftData + " " + styles.dataBlock}>
            {includedFields !== undefined && this.renderFields("Matched Fields", includedFields, "#f2def2")}
          </div>
          <div className={styles.centerData + " " + styles.dataBlock}>
            {extraFields !== undefined && this.renderFields("Extra Fields (Dataset)", extraFields, "#ddf2e6")}
          </div>
          <div className={styles.rightData + " " + styles.dataBlock}>
            {missedFields !== undefined && this.renderFields("Missed Fields (Blueprint)", missedFields, "#caebf6")}
          </div>
        </div>
        <div className={styles.warningsContainer}>{warnings !== undefined && this.renderAutoCorrections(warnings)}</div>
      </div>
    );
  }

  renderColorKey() {
    return (
      <div className={styles.key}>
        <div>Color Key:</div>
        <div className={styles.exampleKey}>
          <div>User Selected</div>
          <div className={styles.userSelected + " " + styles.colorBlock} />
        </div>
        <div className={styles.exampleKey}>
          <div>Blueprint Selected</div>
          <div className={styles.blueprintSelected + " " + styles.colorBlock} />
        </div>
        <div className={styles.exampleKey}>
          <div>Aible Adjustment</div>
          <div className={styles.aibleAdjustment + " " + styles.colorBlock} />
        </div>
      </div>
    );
  }

  renderSetupDetail() {
    const { group } = this.props;

    const setup = group.run.setup;
    const blueprintSetup =
      group.blueprint && group.blueprint.wizard && group.blueprint.wizard.setup
        ? group.blueprint.wizard.setup
        : undefined;

    return (
      <div className={styles.detailContainer}>
        <div className={styles.detailsFlex + " " + styles.outerHolder}>
          {blueprintSetup && (
            <div>
              <div className={styles.dataBlock}>
                <div className={styles.tileHeaderTable}>{"Blueprint Default Impacts"}</div>
                {this.renderSetup(blueprintSetup)}
              </div>
            </div>
          )}
          <div className={styles.vertSplit} />
          <div className={styles.dataBlock}>
            <div className={styles.tileHeaderTable}>{"Setup Impacts"}</div>
            {this.renderSetup(setup, true)}
          </div>
        </div>
      </div>
    );
  }

  renderBlueprintDetail(blueprint) {
    if (blueprint === undefined) {
      return <div />;
    }

    const fields = blueprint.wizard && blueprint.wizard.dataset && blueprint.wizard.dataset.fields;
    const setup = blueprint.wizard && blueprint.wizard.setup;

    return (
      <div className={styles.detailContainer}>
        <div className={styles.detailsFlex + " " + styles.outerHolder}>
          <div className={styles.dataBlock}>
            {fields !== undefined && this.renderFields("Blueprint Fields", fields)}
          </div>
          <div className={styles.vertSplit}></div>
          <div className={styles.dataBlock}>
            <div className={styles.tileHeader}>{"Blueprint Default Impacts"}</div>
            {this.renderSetup(setup)}
          </div>
        </div>
      </div>
    );
  }

  transition(name, styles) {
    if (name) {
      //possibility of double clicking, so instead of looking, lets just check if the state is on
      if (!this.state.detailSelected) {
        document.getElementById("Group").classList.add(styles.padding);
        this.setState({ detailSelected: true });
      }
      this.setState({ showItem: name });
    } else {
      document.getElementById("Group").classList.remove(styles.padding);

      this.setState({ detailSelected: false });
      setTimeout(
        function () {
          this.setState({ showItem: name });
        }.bind(this),
        400
      );
    }
  }

  renderTile(name, tile, hideArrow = false, disableClick = false) {
    return (
      <div
        className={styles.groupTile}
        onClick={disableClick === true ? () => {} : () => this.transition(name, styles)}
      >
        <div className={styles.tileHeader}>{name}</div>
        {tile}
        {false && disableClick !== true && (
          <div className={styles.details}>
            <Button type="secondary">{"Show Details"}</Button>
          </div>
        )}
        {hideArrow !== true && (
          <div className={styles.rightIcon} style={name === "Setup" ? { right: "-30px" } : {}}>
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    return;
  }

  render() {
    const { group } = this.props;
    const { showItem } = this.state;

    const isLoading = group && group.run && group.run.id === undefined;
    return (
      <div className={styles.group}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <React.Fragment>
            <div id="Group" className={styles.groupHolder}>
              {this.renderColorKey()}
              {group.blueprint &&
                group.blueprint.id !== undefined &&
                this.renderTile("Blueprint", <BlueprintItem id={group.blueprint.id} isTile onClick={() => {}} />)}
              {group.dataset &&
                group.dataset.id !== undefined &&
                this.renderTile("Dataset", <DatasetItem id={group.dataset.id} isTile onClick={() => {}} />)}
              {group.run &&
                group.run.setup !== undefined &&
                this.renderTile("Setup", <Setup setup={group.run.setup} isSmall />)}
              {group.run &&
                group.run.id !== undefined &&
                this.renderTile("Model", <RunItem id={group.run.id} isTile onClick={() => {}} />, false, true)}
              {group.deployments &&
                group.deployments[0] &&
                group.deployments[0].id !== undefined &&
                group.run &&
                group.run.id &&
                this.renderTile(
                  "Deployments",
                  <DeploymentItem jobId={group.run.id} modelId={group.deployments[0].model_name} isTile />,
                  true,
                  true
                )}
            </div>
            <div
              className={styles.detailHolder}
              style={showItem === undefined ? { visibility: "hidden" } : { justifyContent: "Center" }}
            >
              <div className={styles.hideButton}>
                <Button type="secondary" onClick={() => this.transition(undefined, styles)}>
                  {"Hide Details"}
                </Button>
              </div>
              {showItem === "Blueprint" && this.renderBlueprintDetail(group.blueprint)}
              {showItem === "Dataset" && this.renderDatasetDetail()}
              {showItem === "Setup" && this.renderSetupDetail()}
              {showItem === "Model" && <RelatedSuccess id={group.run && group.run.id} isShow isRenderFirst />}
              {showItem === "Deployments" && <RelatedSuccess id={group.run.id} isShow isRenderSecond />}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}
